import ClickCollectPlaceholder from './clickCollectPlaceholder.component';

export default ClickCollectPlaceholder;
